import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputCombo from "../../helpers/InputCombo";
import MenuNormal from "../../helpers/MenuNormal";
import InputDate from "../../helpers/InputDate";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import MenuTable from "../../helpers/MenuTable";
import ClientReview from "../home/ClientReview";
import InputTextArea from "../../helpers/InputTextArea";



function NotsForm(props)
{
            
            const [checked1, setChecked1] = useState(false);
            const handleChange1= () => {
                setChecked1(!checked1);
            };  

            const [checked2, setChecked2] = useState(false);
            const handleChange2= () => {
                setChecked2(!checked2);
            };  


            const [checked3, setChecked3] = useState(false);
            const handleChange3= () => {
                setChecked3(!checked3);
            };  


            const [checked4, setChecked4] = useState(false);
            const handleChange4= () => {
                setChecked4(!checked4);
            };  


            const [errTab, setErrTab] = useState([]); 


            const defPoz = [
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                    {  id: -1,  nazwa_pozycji: '', kwota_obciazenia:0.00, kwota_uznania: 0.00,   },                
                ];



            const [row, setRow] = useState({
                id: -1,
                fak_kontrahenci_id: -1,
                
                razem_uznan: 0,
                razem_obciazen: 0,
                data_wystawienia: '',
                miejsce_wystawienia: '',
                termin_platnosci: '',
                anulowana: '',
                numer_noty: '',
                zatwierdzona: '',
                do_zaplaty: '',
                kwota_rozliczenia: '',

                kl_nazwa: '',
                kl_ulica: '',
                kl_kod_pocztowy: '',
                kl_miejscowosc: '',
                kl_nip: '',

                odb_nazwa: '',
                odb_ulica: '',
                odb_kod_pocztowy: '',
                odb_miejscowosc: '',
                odb_nip: '',

                numer_rachunku: '',

                sp_nazwa: '',
                sp_ulica: '',
                sp_kod_pocztowy: '',
                sp_miejscowosc: '',
                sp_nip: '',
          
                poz_max: 1,
                pozycje: defPoz,

            }); 

            var tmpRow = row;

            const [goCalculate, setGoCalculate] = useState(0);       
            const [isChanged, setIsChanged] = useState(0); // jesli 1 to cos zostalo zmienione..



            const [nParam, setNParam] = useState(''); //parametr ogolnego przeznaczenia..

            const paramListener = (filedName, val, correct, msg) => { 
                setNParam(val);
            }


            const [view, setView] = useState ( {view:"list", id: -1}  );

            const onBack = (e) => {
                setView({view:"list", id: -1}  );
            }

            const onSuccess = (e) => {
                setView({view:"list", id: -1}  );
                getCalcDet();
            }

             const changeView = (e ) => {
                    var v = e.target.getAttribute('v');
                    var id = e.target.getAttribute('id');

                    setView({...view, ["v"]:v, ["id"]:id });
            }


            const recalculateAmong = () => {

                 
                        var tabRef = JSON.parse(  JSON.stringify(row) ); //new ref

                        var tRef    = tabRef["pozycje"];

                        var sumUznan    = 0;
                        var sumObciazen = 0;      

                        for(var x=0; x < tRef.length; x++)
                        {
                            var cUznan =  parseFloat( tRef[x]["kwota_uznania"] );
                            var cObciazen =  parseFloat( tRef[x]["kwota_obciazenia"] );

                            
                             sumUznan    = parseFloat( parseFloat( sumUznan) + parseFloat( cUznan  )  ).toFixed(2);
                             sumObciazen      = parseFloat( parseFloat( sumObciazen) +  parseFloat( cObciazen  )  ).toFixed(2);                      

                        }

                        tabRef['razem_uznan'] = sumUznan;;  
                        tabRef['razem_obciazen'] = sumObciazen;                    

                         var doZaplaty  =     parseFloat (parseFloat(sumUznan) - parseFloat(sumObciazen));
                         doZaplaty   =  parseFloat (-1 * parseFloat(doZaplaty) ).toFixed(2);

                         tabRef['do_zaplaty'] = doZaplaty;

  

                        setRow(tabRef);
                        setGoCalculate(0); //przeliczono


            }

            const valChangeListener = (filedName, val, correct, msg) => {                         
        
                if(row.anulowana == 1) return;
                if(row.zatwierdzona != 0 && row.zatwierdzona  != -10 ) return;


                setIsChanged(1);

                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 3) //pozycje..
                {

                    console.log(tabCheck);
                

                    var tabName    = tabCheck[0];
                    var tabInx     = tabCheck[1];
                    var filedName  = tabCheck[2];

                    var tRef    = row[tabName];
                    tRef[tabInx][filedName] = val;
                    tmpRow[tabName] = tRef;     

 

                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
                    setGoCalculate(1); //niech przeliczy jeszcze raz               
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;             
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );                             
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                        
            }   
        
        
            const goNextNew = () => {
                        console.log("goNext");               
                    }



            const valChecker = (fields) => {

                    var allValid = true;

                        
                    console.log(JSON.stringify(fields) );

                    Object.entries(fields).forEach(function(entry) {

                        var xKey    = entry[0];
                        var xValue  = entry[1];                    

                        var xValidName = xKey + "_valid";

                        if(fields[xValidName] == false)
                        {
                            allValid = false;
                            if(Config.env == 'dev') console.log("Error field: " + xKey);
                        }
                        
                    });
                    
                    return allValid;

                }

                

            const getCalcDet = () => {    

                 
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_calc,note_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    var resX = res.result;     
                                    
                                    resX["poz_max"] = res.result.pozycje.length;
                                    
                                    for(var x = 0; x < defPoz.length; x++)
                                    {                                        
                                         if( resX.pozycje[x] == undefined || resX.pozycje[x] == null )       
                                         {                                           
                                             resX.pozycje[x] =    defPoz[x] ;
                                         }
                                         
                                    }


                                    setRow(resX);  

                                    setTimeout(()=>{
                                            setIsChanged(0); 
                                    }, 200);                                                                                                              
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                } 


            const addItem = () => {
               
                setRow( {...row, ["poz_max"]: row.poz_max+1 } );
                setGoCalculate(1); //niech przeliczy jeszcze raz       

                setTimeout( ()=>{

                    //f_poz_name                  
                    var el = document.getElementsByClassName("f_poz_name");
                    //console.log(el[el.length-1]);
                    el[el.length-1].focus();
                   

                }, 200 );
            }    


            const removeItem = (e) => {
               
                    var inx = e.target.getAttribute('atr-inx');

                    var newArra = [];

                    for(var k=0; k< row.pozycje.length; k++)
                    {
                        if(k == inx) continue;

                        newArra.push( row.pozycje[k] );
                    }

                    
                    setRow({...row, ["pozycje"]: newArra , ["poz_max"]: (row.poz_max-1) } );                                       
                    setGoCalculate(1); //niech przeliczy jeszcze raz                 
            }



            const goUnlock = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz cofnąć wystawiony dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,not_unlock', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument odblokowany. Pamiętaj by zatwierdzić go ponownie." , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                } 


            const goApprove = (e) => {    

                    if(row.poz_max < 1)
                    {
                        props.mainView.showDialog( "Ups!", "Nie można zatwierdzić - dokument nie zawiera żadnych pozycji" , "ok" , null);
                        return; 
                    }

                    if(isChanged == 1)
                    {
                         props.mainView.showDialog( "Potwierdź", "Przed wystawieniem dokumentu zapisz zmiany." , "ok" , null);
                        return;
                    
                    }
                   
                    var send = '0';

                    if(e != undefined && e.target != undefined)
                    {
                        send = e.target.getAttribute("atr-send");
                    }


                 

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz wystawić dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,not_approve', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id, send: send}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {                                                        
                                                         props.mainView.showDialog( "Sukces", "Operacja zakończona sukcesem, ilość wystawionych dokumentów: " + res.result , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                } 



            const goCancel = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz anulować wystawiony dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,not_cancel', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument został anulowany." , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                }   
                
            const goSend = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz wysłać dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,not_send', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument został wysłany" , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                }  
            
              
              const goPrint = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz wydrukować dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,not_print', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument został wysłany do drukarki" , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                }     

            const goUpdate = () => {   
                              
              //   if(row.anulowana != 0 || row.zatwierdzona != 0 || row.zatwierdzona != -10  ) return;


                if(row.data_wystawienia.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj datę wystawienia dokumentu" , "error" , null);  
                     setChecked1(1); setChecked2(0); setChecked3(0); setChecked4(0);
                     return;
                }
 

                if(row.termin_platnosci.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj termin płatności" , "error" , null);  
                     setChecked1(1); setChecked2(0); setChecked3(0); setChecked4(0);
                     return;
                }

                 if(row.sp_nip.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj NIP sprzedawcy" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_nazwa.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj nazwę sprzedawcy" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_ulica.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe sprzedawcy (ulica)" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_kod_pocztowy.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe sprzedawcy (kod pocztowy)" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_miejscowosc.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe sprzedawcy (miejscowość)" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }


                if(row.kl_nip.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj NIP nabywcy" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.kl_nazwa.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj nazwę nabywcy" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.kl_ulica.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe nabywcy (ulica)" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                 if(row.kl_kod_pocztowy.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe nabywcy (kod pocztowy)" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.kl_miejscowosc.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe nabywcy (miejscowość)" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

        

                                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,not_update', {
                                            method: 'POST', 
                                            body: JSON.stringify(row), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                     props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         
                                                         props.mainView.showDialog( "Sukces", "Dokument został zapisany" , "ok" ,  (resp)=>{                                                     
                                                            getCalcDet();
                                                         } );                                                                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });

        

                    return false;
                } 
                

           


            const keyListener = (e) => {

                                var code = e.keyCode ? e.keyCode : e.which;    
                                console.log("keylockd", e.target.nodeName, code );
                               
                                if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                                {
                                    e.target.blur();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                                {                                                                
                                } else
                                if(e.target.nodeName.toLowerCase() == "body" && code == 107 )  // +
                                {
                                    addItem();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                                {
                                        props.onSuccess();                               
                                } else 
                                if( e.shiftKey   && code == 13 )   //enter // wystaw
                                {
                                        goApprove();
                                }else
                                if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       if(row.anulowana != 0 && row.zatwierdzona != 0)
                                       {
                                            props.mainView.showDialog( "Ups!", "Nie można zapisać zmian (dokument wystawiony lub anulowany)" , "error" , null);  
                                       }else{
                                            goUpdate();    
                                       }

                                                            
                                       e.preventDefault();
                                } else 
                                {
                                    props.keyListener(e);
                                }
                    
            }


            useEffect(() => {
                         
                        if(row.id < 0 && props.id > 0 )
                        {
                            getCalcDet();
                        }

                        if(goCalculate == 1)
                        {
                           recalculateAmong();                           
                        }                        

                        if(Config.env == "dev") console.log("NotsForm.js, listener on");
                        window.onkeydown = keyListener;

                        return () => {          
                            if(Config.env == "dev") console.log("NotsForm.js, listener off");      
                            window.onkeydown = props.keyListener;
                        };
            });  
            

            if(row == null )
            {
                return <div>...</div>
            }


            document.title = row.numer_dokumentu;

            if(row.zatwierdzona == 0)
            {
                document.title = "Dokument niezatwierdzony";
            }

            var cssInvoice = "";

            if(row.zatwierdzona == 1) cssInvoice = " approved ";
            if(row.zatwierdzona == 0) cssInvoice = " waiting ";
            if(row.anulowana == 1) cssInvoice = " canceled ";


            var dialog = null;

  

            if(view.v == "client")
            {                                 
                    return <ClientReview  userData={props.userData} mainView={props.mainView}  keyListener={keyListener}  onBack={onBack}  onSuccess={onSuccess}   id={row.klient.id} />
            }




            return <div className="view_content">
                        <img src={back} onClick={props.onSuccess} className="back_img" title="wstecz"/>

                         <div className="location">Panel / Lista not / Szczegóły noty</div>

                          <div className="app_header">                            
                            {
                                row.zatwierdzona == 0 &&
                                <div>
                                    Brak nadanego numeru, dokument nie został jeszcze wystawiony &nbsp;
                                    {
                                        (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1) && 
                                        <sup  className="link_normal"  v="client" id="-1" onClick={changeView}>idź do klienta</sup> 
                                    }
                                </div>
                            }

                        

                            {
                                row.zatwierdzona == 1 &&
                                <div>Nota nr  {row.numer_noty} z dnia {row.data_wystawienia} &nbsp;
                                    {
                                        (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1) && 
                                        <sup  className="link_normal"  v="client" id="-1" onClick={changeView}>idź do klienta</sup> 
                                    }
                                    
                                </div>
                            }

                             
                        </div>

                        <div className={"client_info " + cssInvoice}>                             

                            { 
                                  row.zatwierdzona == 1 && row.anulowana == 1 && 
                                  <Fragment>
                                        <b>Anulowany</b>                                                                          
                                  </Fragment>                                  
                             }
                             { 
                                  row.zatwierdzona == 1 && row.anulowana == 0 && 
                                  <Fragment>
                                        <b>Zatwierdzona</b>                                    
                                        <MenuNormal>
                                            <ul>
                                                <li onClick={goUnlock}>cofnij wyst.</li>                         
                                                <li onClick={goCancel}>anuluj dokument</li>                         
                                                <li onClick={goSend}>wyślij dokument</li>                         
                                                <li onClick={goPrint}>drukuj</li>                         
                                                <li  atr-id={row.id} atr-title={row.numer_noty} onClick={props.goDownload}>pobierz pdf</li>                                                                 
                                            </ul>
                                        </MenuNormal> 
                                  </Fragment>                                  
                             }

                              { 
                                  (row.zatwierdzona == 0 ) &&  row.anulowana == 0  && row.poz_max > 0 && isChanged == 0 &&
                                  <Fragment>
                                        <b>Oczekuje na wystawienie</b>                                     
                                        <MenuNormal>
                                            <ul>
                                                <li atr-send="0" onClick={goApprove}>wystaw</li>
                                                <li  atr-send="1" onClick={goApprove}>wystaw i wyślij</li>
                                                <li  atr-id={row.id} atr-title={row.numer_noty} onClick={props.goDownload}>podgląd pdf</li>    
                                            </ul>
                                        </MenuNormal> 
                                  </Fragment>                                  
                             }                          

                             &nbsp; Razem uznań: <b><FormatDecimal value={row.razem_uznan} /> </b>
                             &nbsp; Razem obciążeń: <b><FormatDecimal value={row.razem_obciazen} /> </b>              
                             &nbsp; Do zapłaty: <b><FormatDecimal value={row.do_zaplaty} /> </b>
                        </div>

                     

                        <div className={"client_info " }>   

                          
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked1}  onChange={handleChange1}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp; 

                            Data wystawienia: <b>{row.data_wystawienia}</b>                          
                            &nbsp;
                            Płatne do: <b>{row.termin_platnosci}</b>
                            {
                                checked1 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">
                                            <div className="form_control">
                                                <div className="fieldName">Data wystawienia*</div>
                                                <InputDate  value={row.data_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"data_wystawienia"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                            
                                            <div className="form_control">
                                                <div className="fieldName">Termin płatności*</div>
                                                <InputDate  value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"termin_platnosci"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>
                                    </div>
                                </Fragment>
                               
                            }
                        </div>

                        <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked2}  onChange={handleChange2}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp; 

                            <b>Sprzedawca: </b> {row.sp_nip} {row.sp_nazwa} {row.sp_ulica}   {row.sp_kod_pocztowy} {row.sp_miejscowosc}
                               {
                                checked2 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">

                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP  value={row.sp_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_nip"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText  value={row.sp_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_nazwa"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>    

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText  value={row.sp_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_ulica"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>     

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputPostCode  value={row.sp_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_kod_pocztowy"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText  value={row.sp_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_miejscowosc"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                      
                                    </div>
                                </Fragment>
                               
                            }
                        </div>

                        <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked3}  onChange={handleChange3}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp;           
                            <b>Nabywca:</b> {row.kl_nip}  {row.kl_nazwa} {row.kl_ulica} {row.kl_kod_pocztowy} {row.kl_miejscowosc}
                             {
                                checked3 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">

                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP  value={row.kl_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_nip"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText  value={row.kl_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_nazwa"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>    

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText  value={row.kl_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_ulica"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>     

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputPostCode  value={row.kl_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_kod_pocztowy"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText  value={row.kl_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_miejscowosc"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                      
                                    </div>
                                </Fragment>
                               
                            }
                        </div>
                        
                     

                      <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked4}  onChange={handleChange4}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp;           
                            <b>Odbiorca:</b> {row.odb_nip}  {row.odb_nazwa} {row.odb_ulica} {row.odb_kod_pocztowy} {row.odb_miejscowosc}
                             {
                                checked4 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">

                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP  value={row.odb_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odb_nip"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText  value={row.odb_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odb_nazwa"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>    

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText  value={row.odb_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odb_ulica"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>     

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputPostCode  value={row.odb_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odb_kod_pocztowy"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText  value={row.odb_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odb_miejscowosc"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                      
                                    </div>
                                </Fragment>
                               
                            }
                        </div>
                        

 

                      
                        <form className="eForm eForm100 bg_center">

                                <div className="form_tab_title">Pozycje na dokumencie ({row.poz_max}):</div>
                                 <div className="form_tab">


                                        {
                                            row.anulowana == 0 && (row.zatwierdzona == 0 || row.zatwierdzona == -10) &&
                                            <Fragment>
                                                    <table>

                                                                                                {
                                                                                                    row.pozycje.map(  (poz, inx) => {

                                                                                                            if(inx >= row.poz_max) return null;

                                                                                                            return <tr className="fromRightToLeft">

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Nazwa*</div>
                                                                                                                            <InputText   userData={props.userData} value={poz.nazwa_pozycji} err={errTab}  valChange={valChangeListener} goNext={null} name={"pozycje@"+inx+"@nazwa_pozycji"} placeholder={"Nazwa: "} className=' w400 f_poz_name ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>
 
                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Kwota uznania*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.kwota_uznania} err={errTab}  valChange={valChangeListener} goNext={null} name={"pozycje@"+inx+"@kwota_uznania"} placeholder={"Kwota uznania: "} className=' w100 ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>


                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Kwota obciążenia*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.kwota_obciazenia} err={errTab}  valChange={valChangeListener} goNext={null} name={"pozycje@"+inx+"@kwota_obciazenia"} placeholder={"Kwota obciążenia: "} className=' w100 ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>


                                                                                                                <td>
                                                                                                                    &nbsp; 
                                                                                                                    {
                                                                                                                        row.zatwierdzona != 1 &&
                                                                                                                        <span className="btn" atr-inx={inx} onClick={removeItem}> usuń </span>
                                                                                                                    }                                                                
                                                                                                                </td>

                                                                                                            </tr>


                                                                                                    } )

                                                                                                }

                                                    </table>
                                                                                        {
                                                                                            row.zatwierdzona != 1 && 
                                                                                            <div onClick={addItem} className="btn">dodaj pozycje[+]</div>
                                                                                        }   
 

                                            </Fragment> 
                                        }



                                        {
                                            (!( row.anulowana == 0 && (row.zatwierdzona == 0  ) )) &&
                                            <Fragment>
                                                       <table className="table"  >

                                                            <tr className="header">                                                                                               
                                                                <td className="td_left">LP</td>
                                                                <td>Nazwa</td>                                                              
                                                                <td>Kwota obciążenia</td>                                                                        
                                                                <td>Kwota uznania</td>                                                                                                                                                                                                             
                                                                <td className="td_right" >Razem</td>                                                                                                                                                                                                         
                                                            </tr>

                                                            {
                                                                   row.pozycje.map(  (poz, inx) => {

                                                                            if(inx >= row.poz_max) return null;

                                                                            var rowStyle = " row ";
                                                                            if(inx % 2 == 0 )rowStyle = " row2 ";


                                                                            return <tr className={rowStyle}>                                                                                                                                                                           
                                                                                <td className="gocenter">{inx+1}</td>
                                                                                <td>{poz.nazwa_pozycji}</td>                                                                                                                                                                                                             
                                                                                <td className="goright"><FormatDecimal value={poz.kwota_obciazenia} /> </td>                                                                        
                                                                                <td className="goright"><FormatDecimal value={poz.kwota_uznania} /> </td>                                                                        
                                                                                <td className="goright"><FormatDecimal value={  parseFloat( poz.kwota_obciazenia - poz.kwota_uznania )  } /> </td>                                                                                                                                                                                                                                    
                                                                            </tr>


                                                                   }) 
                                                            }

                                                          

                                                       </table>
                                            </Fragment>
                                        }
                                    
                                                                             
                                     

                                 </div>


                            

                                 
                                <div className="form_split"></div>

                                <div className="app_header">                            
                                    Do zapłaty: <FormatDecimal value={row.do_zaplaty} />

                                    {
                                        row.roznica != undefined && row.roznica > 0 &&
                                        <div>
                                            Dopłata względem dokumentu pierwotnego {row.org_faktura.numer_dokumentu}  wynosi: <FormatDecimal value={row.roznica}  />
                                        </div>
                                    }
                                    {
                                        row.roznica != undefined && row.roznica <= 0 &&
                                        <div>
                                            Niedopłata względem dokumentu pierwotnego  {row.org_faktura.numer_dokumentu}, wynosi: <FormatDecimal value={row.roznica}  />
                                        </div>
                                    }
                                </div>

                                <div className="form_split"></div>

                                <div className="form_btn">

                                        {                                                                         
                                              (row.zatwierdzona == 0 || row.zatwierdzona == -10 ) &&  row.anulowana == 0  && row.poz_max > 0 && isChanged == 0 &&
                                              <Fragment>
                                                   <div className="btn" onClick={goApprove} atr-send="0" >wystaw bez wysyłki [shift +e enter]</div>
                                                   &nbsp; &nbsp;
                                              </Fragment>
                                        }

                                        {
                                            row.anulowana == 0 && (row.zatwierdzona == 0 || row.zatwierdzona == -10) &&
                                            <div className="btn" onClick={goUpdate}>zapisz zmiany [cntr+s]</div>
                                        }
                                        
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onSuccess}    > wyjdź [back]</div>
                                </div>

                        </form>


                         {
                            row.duplikaty != undefined &&
                            <Fragment>
                                      <div className="bg_center">
                                         <h3 className="dash_header">Duplikaty faktury {row.numer_dokumentu} ({row.duplikaty.length})</h3>

                                          <table className="table"  >
                                            
                                                    <thead>
                                                        <tr className="header">                                                                                               
                                                            <td className="td_left">LP</td>
                                                            <td>Numer</td>                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td className="td_right">Data wystawienia</td>                                                                                                                                      
                                                            <td className="td_option"></td>                                                                                  
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {
                                                            row.duplikaty.map( (item, ix) => {

                                                                    var rowStyle = " row ";
                                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                    return <tr className={rowStyle} key={ix}>
                                                                                <td className="gocenter">{ix+1}</td>    
                                                                                <td className="gocenter">{item.numer_dokumentu}</td>    
                                                                                <td className="gocenter">{item.data_wystawienia}</td>    
                                                                                <MenuTable>
                                                                                <ul>                                                                                    
                                                                                    <li   onClick={ props.goDownload } atr-id ={ item.id } atr-title ={ item.numer_dokumentu }  > Pobierz </li>                                                                                
                                                                                </ul>
                                                                            </MenuTable>
                                                                        </tr>

                                                            } )
                                                        }

                                                    </tbody>

                                          </table>
                                      </div>
                            </Fragment>
                         }

                        {dialog}                
                    </div>
}


export default NotsForm;